import { SiWhatsapp } from "react-icons/si";
import { Button } from "@/components/ui/button";

export function WhatsAppButton() {
  const phoneNumber = "05334580556";
  
  const handleWhatsAppClick = () => {
    const message = encodeURIComponent("Merhaba, araç yıkama hakkında bilgi almak istiyorum.");
    window.open(`https://wa.me/${phoneNumber}?text=${message}`, "_blank");
  };

  return (
    <Button
      onClick={handleWhatsAppClick}
      size="icon"
      className="fixed bottom-6 right-6 z-[9999] h-14 w-14 rounded-full shadow-lg bg-green-600 hover:bg-green-700 hover:scale-110 transition-all"
      data-testid="button-whatsapp-float"
      aria-label="WhatsApp ile iletişime geç"
    >
      <SiWhatsapp className="w-7 h-7 text-white" />
    </Button>
  );
}
